import { NO, YES } from "uicore-ts"


/**
 * RHClipboard — one place to copy text to the system clipboard.
 *
 * Prefers the async Clipboard API (requires a secure context: https or
 * localhost) and falls back to a hidden-textarea + execCommand copy for older
 * browsers / non-secure contexts. Returns whether the copy succeeded so the
 * caller can show the right confirmation.
 */
export class RHClipboard {

    static async copy(text: string): Promise<boolean> {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text)
                return YES
            }
        }
        catch (error) {
            // Fall through to the legacy path below.
        }
        return RHClipboard._legacyCopy(text)
    }


    private static _legacyCopy(text: string): boolean {
        const textArea = document.createElement("textarea")
        textArea.value = text
        // Keep it out of view and out of the layout flow while it is briefly selected.
        textArea.style.position = "fixed"
        textArea.style.top = "-1000px"
        textArea.style.opacity = "0"
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        let didCopy = NO
        try {
            didCopy = document.execCommand("copy")
        }
        catch (error) {
            didCopy = NO
        }

        document.body.removeChild(textArea)
        return didCopy
    }

}
